import { useTranslation } from 'react-i18next'

import { LABEL_ENTITY_VALUE } from '../../../Label'
import { ProfileLabelsWidget } from '../../../Widget'
import { useRequestProfileContext } from '../../RequestProfile.hooks'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS } from './RequestProfileWidgetLabels.constants'
import { useRequestProfileWidgetLabelDelete } from './RequestProfileWidgetLabels.hooks'
import {
  getInitialValues,
  getPayload,
  getWidgetLabels,
} from './RequestProfileWidgetLabels.utils'
import { RequestProfileWidgetLabelsItem } from './RequestProfileWidgetLabelsItem'

function RequestProfileWidgetLabels({ isSkeleton }) {
  const { t } = useTranslation()

  const { handleCloseModal, handleUpdateEntity, requestData } =
    useRequestProfileContext()

  const labels = requestData?.labels

  const { handleDeleteLabel } = useRequestProfileWidgetLabelDelete({ labels })

  const initialValues = getInitialValues(labels)
  const widgetLabels = getWidgetLabels(labels)

  const canEditLabels = Boolean(requestData?.permissions?.can_edit_labels)

  return (
    <ProfileLabelsWidget
      canEdit={canEditLabels}
      formProps={{
        entity: LABEL_ENTITY_VALUE.request,
        fieldName: REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS,
        getPayload,
        initialValues,
        placeholder: t('RequestProfile.LabelsWidgetPlaceholderKey'),
        onClose: handleCloseModal,
        onSubmit: handleUpdateEntity,
      }}
      isSkeleton={isSkeleton}
      items={widgetLabels}
      listProps={{
        Item: RequestProfileWidgetLabelsItem,
        itemProps: {
          canDelete: canEditLabels,
          onDelete: handleDeleteLabel,
        },
        title: t('RequestProfile.LabelsWidgetListTitleKey', {
          count: widgetLabels.length,
        }),
      }}
      title={t('RequestProfile.LabelsWidgetTitleKey')}
      widgetProps={{
        headerProps: {
          contentProps: {
            actionsProps: {
              addButtonProps: {
                tooltipKey: 'RequestProfile.LabelsWidgetAddButtonTooltipKey',
              },
            },
          },
        },
        qaName: RequestProfileWidgetKey.LABELS,
      }}
    />
  )
}

export default RequestProfileWidgetLabels
